import React from "react";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import WebhookIntegration from "./components/WebhookIntegration/WebhookIntegration";
import WebBasedIntegration from "./components/WebBasedIntegration/WebBasedIntegration";
import ShopifyIntegration from "./components/ShopifyIntegration/ShopifyIntegration";
import VerificationWebhookIntegration from "./components/VerificationWebhookIntegration/VerificationWebhookIntegration";
import PageNotFound from "./components/PageNotFound/PageNotFound";
import useGetParameterByName from "./helpers/useGetParameterByName";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationsInEng from "./locales/en/translation.json";
import translationsInSpanish from "./locales/es/translation.json";


import "./App.css";

function App() {
  const langFromUrl = useGetParameterByName("lang");

  const resources = {
    EN: {
      translation: translationsInEng,
    },
    ES: {
      translation: translationsInSpanish,
    },
  };

  i18n.use(initReactI18next).init({
    resources,
    lng: langFromUrl === "" ? "EN" : langFromUrl,
    debug: false,
    fallbackLng: "ES",
    interpolation: {
      escapeValue: false,
    },
    ns: "translation",
    defaultNS: "translation",
  });

  return (
    <div className="App">
      <I18nextProvider i18n={i18n}>
        <Router>
          <Routes>
            <Route
              path="/vending-machines-integration"
              element={<WebhookIntegration />}
            />
            <Route
              path="/webhook-integration"
              element={<Navigate to="/vending-machines-integration" replace />}
            />
            <Route
              path="/web-based-integration"
              element={<WebBasedIntegration />}
            />
            <Route
              path="/shopify-integration"
              element={<ShopifyIntegration />}
            />
            <Route
              path="/verification-process-data"
              element={<VerificationWebhookIntegration />}
            />
            <Route
              path="/verification-webhook-integration"
              element={<Navigate to="/verification-process-data" replace />}
            />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </Router>
      </I18nextProvider>
    </div>
  );
}

export default App;
